import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import WarningPage from './WarningPage';
import WarningLoading from './WarningLoading';
import useMyView from './useMyView';
import { WD, FONT_SERIF } from './warningTheme';

// Plain wording, shared with the landing page so both say the same thing.
export const NO_PERFORMANCE_METRICS_TITLE = "Performance Metrics isn't available for your department";
export const NO_PERFORMANCE_METRICS_HELP = 'Ask Finance if you need access.';

// Wraps every Performance Metrics result page (see DashboardRouter.js). Finance can switch Performance Metrics off for a
// department (Who can see Performance Metrics); a person in such a department who opens a metric page - from a bookmark, say -
// gets this plain panel with a way back, not an error. The server enforces it too (requirePerformanceMetricsAccess): this is the
// friendly part. Waits for the one my-view answer (remembered, so it is instant after the landing page); a failed or missing
// answer lets the page open.
const PerformanceMetricsGuard = ({ children }) => {
  const { view, performanceMetrics } = useMyView();
  if (view === null) {
    return (
      <WarningPage title="Performance Metrics">
        <WarningLoading />
      </WarningPage>
    );
  }
  if (performanceMetrics === false) {
    return (
      <WarningPage
        title="Performance Metrics"
        actions={<Button component={Link} to="/dashboard/warning-dashboard" variant="text">Back to Warning Dashboard</Button>}
      >
        <Box sx={{ textAlign: 'center', py: 6, px: 2, bgcolor: '#fff', border: `1px dashed ${WD.border}`, borderRadius: '16px' }}>
          <Typography sx={{ fontFamily: FONT_SERIF, fontSize: 20, fontWeight: 600 }}>{NO_PERFORMANCE_METRICS_TITLE}</Typography>
          <Typography sx={{ fontSize: 14, color: WD.inkMuted, mt: 0.75 }}>{NO_PERFORMANCE_METRICS_HELP}</Typography>
        </Box>
      </WarningPage>
    );
  }
  return children;
};

export default PerformanceMetricsGuard;
